import React, { Component } from 'react';
import { NavBar, Icon, Toast } from 'antd-mobile';
import Utility from 'UTIL/utility';
import { browserHistory } from 'react-router';
import $ from 'jquery';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      position: '',
      footerMarginT: '0',
      footerMarginB: '0',
      isShowHeader: '0',
    };
  }

  componentWillMount() {
    // Utility.hideKeyBoard();
    Utility.setTitle(typeof this.props.title === 'string' ? this.props.title : 'hfive');
    Toast.hide();
  }

  componentDidMount() {
    $(window).resize(() => {
      this.staticToFixed();
    });
    this.staticToFixed();

  }

  componentDidUpdate() {
    this.staticToFixed();

    if (this.state.isShowHeader === '1') {
      $('.page-body').css('paddingTop', '0');
    }
  }

  goToHelpCenter = () => {
    browserHistory.push('/helpCenter/helpCommon');
  };

  goToAliService = () => {
    browserHistory.push('/aliService');
  };

  renderRight = () => this.props.renderRight();

  // 调整页面
  staticToFixed = () => {
    if ($('.layoutContainer').height() / window.innerHeight > 0.9) {
      $('.page-footer').css('position', 'relative');
      $('.page-footer').css('bottom', '0.5rem');
      $('.page-footer').css('margin-top', '2rem');
      $('.page-footer').css('margin-bottom', '1rem');

      $('.page-footer.footerLogo-o').css('position', 'relative');
      $('.page-footer.footerLogo-o').css('bottom', '0');
      $('.page-footer.footerLogo-o').css('margin-top', '2rem');
      $('.page-footer.footerLogo-o').css('margin-bottom', '0');
    } else {
      $('.page-footer').css('position', 'fixed');
    }
  };

  renderFooter = () => {
    
  };

  render() {
    return (
      <div className="layoutContainer">
        <div className="contentContainer">
          {(this.state.isShowHeader === '1'|| this.props.isShowHeader) ? (
            <NavBar
              mode="dark"
              icon={this.props.isHideLeft ? '' : <Icon type="left" />}
              onLeftClick={this.props.backTo}
              rightContent={this.props.isShowRight ? this.renderRight() : ''}
            >
              {this.props.title}
            </NavBar>
          ) : (
            ''
          )}

          {this.props.children}
        </div>

        {this.renderFooter()}
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/component/layout.js